export enum ButtonStyle {
    Basic = 1,
    Primary = 2,
    Secondary = 3,
    Hyperlink = 4
}